module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Upload 上传组件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "220px"
    }
  }, [_c('upload', {
    attrs: {
      "name": 'img'
    },
    on: {
      "fileChanged": _vm.fileChanged
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("HTML代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div style=\"width: 220px;\">\n  <!--宽度由外层容器决定，总是占满外层容器-->\n  <upload :name=\"'img'\" @fileChanged=\"fileChanged\"></upload>\n</div>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Script代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("data() {\n  return {}\n},\nmethods: {\n  fileChanged(file) {\n    const msg = file ? `文件名：${file.name}` : '没有选取任何文件'\n    const msgType = file ? 'success' : 'warning'\n    this.$message({\n      content: msg,\n      type: msgType\n    })\n  }\n}\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Binding attributes 绑定属性")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("input[type=\"file\"]标签的name, 用于嵌在form标签中使用")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Attribute Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Argument")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("fileChanged")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("file(选中的文件)")]), _vm._v(" "), _c('td', [_vm._v("文件变动后的回调事件")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26703695"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/upload-demo.vue
// module id = 388
// module chunks = 1